import type { ComponentType } from 'react'
import {
  ChatsCircle,
  ClockCountdown,
  Microphone,
  PlugsConnected,
  TelegramLogo,
  TreeStructure,
  type IconProps,
} from '@phosphor-icons/react'

/** Features with a page of their own under /funktsii/ (hub: /funktsii). */
export interface FeaturePage {
  path: string
  title: string
  text: string
  icon: ComponentType<IconProps>
}

export const FEATURE_PAGES: FeaturePage[] = [
  {
    path: '/funktsii/ai-agent-dlya-dzvinkiv',
    title: 'AI-агент на вхідних дзвінках',
    text: 'Відповідає клієнтам голосом українською, записує в календар і передає заявки.',
    icon: ChatsCircle,
  },
  {
    path: '/funktsii/ivr-menyu',
    title: 'IVR-меню і сценарії',
    text: 'Голосове меню, робочі години й маршрути дзвінків у візуальному конструкторі.',
    icon: TreeStructure,
  },
  {
    path: '/funktsii/zapys-i-transkryptsiya-dzvinkiv',
    title: 'Запис і транскрипція дзвінків',
    text: 'Кожна розмова записана й розшифрована: слухайте або читайте в кабінеті.',
    icon: Microphone,
  },
  {
    path: '/funktsii/integratsiya-z-crm',
    title: 'Інтеграція з CRM',
    text: 'Заявки, записи й підсумки дзвінків у вашій CRM через вебхуки та API.',
    icon: PlugsConnected,
  },
  {
    path: '/funktsii/zayavky-v-telegram',
    title: 'Заявки в Telegram',
    text: 'Нова заявка чи запис приходить у Telegram за секунди після дзвінка.',
    icon: TelegramLogo,
  },
  {
    path: '/funktsii/robota-24-7',
    title: 'Робота 24/7 і в неробочий час',
    text: 'Вночі, у вихідні й у пікові години дзвінок не лишається без відповіді.',
    icon: ClockCountdown,
  },
]
